import React, { useRef, useEffect } from "react";
import { Chart } from "chart.js/auto";
import styles from "./UnDeliveredCardGraphComponent.module.css";

const UnDeliveredCardGraphComponent = ({ data, elementForCurrentMonth }) => {
  const chartRef = useRef(null);

  const months = [
    "Jan 20",
    "Feb 20",
    "Mar 20",
    "Apr 20",
    "May 20",
    "Jun 19",
    "Jul 19",
    "Aug 19",
    "Sep 19",
    "Oct 19",
    "Nov 19",
    "Dec 19",
    
  ];

  const summation = (data) => {
    return data.reduce((sum, value) => sum + value, 0);
  };

  useEffect(() => {
    let chartInstance = null;

    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      chartInstance = new Chart(ctx, {
        type: "line",
        data: {
          labels: months,
          datasets: [
            {
              data: data,
              borderColor: "rgba(255, 159, 64, 1)",
              borderWidth: 2,
              fill: true,
              backgroundColor: "rgba(255, 159, 64, 0.3)",
              tension: 0,
              pointBorderWidth: 0,
              pointHoverRadius: 0,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              display: false,
            },
            y: {
              display: false,
            },
          },
        },
      });
    }

    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, [data]);

  return (
    <div className={styles.DeliveredCardGraphComponentMasterContainer}>
      <div className={styles.DeliveredCardGraphComponentContainer}>
        <div className={styles.infoContainer}>
          <p>عدد البطاقات الغير مسلمة</p>
          {/* <h2>{summation(data)}</h2> */}
          <h2>{elementForCurrentMonth}</h2>
          <p className={styles.percentage}>
            1.2% <span>⬇</span> than last year
          </p>
        </div>
        <div className={styles.chartContainer}>
          <canvas ref={chartRef}></canvas>
        </div>
      </div>
    </div>
  );
};

export default UnDeliveredCardGraphComponent;
